<template>
    <label class="radio" :class="`is-${size}`">
        <input type="radio" :value="nativeValue" v-model="computedValue" >
        <span class="check"></span>
        <span class="check-label"><slot /></span>
    </label>
</template>

<script>
export default {
    props: {
        value: [Boolean, Array, Object, String],
        nativeValue: [String, Object, Boolean],
        size: {
            type: String,
            default: "normal"
        }
    },
    data() {
        return {
            newValue: this.value
        }
    },
    computed: {
        computedValue: {
            get() {
                return this.newValue
            },
            set(value) {
                this.newValue = value
                this.$emit('input', value)
            }
        }
    },
    watch: {
        value(value) {this.newValue = value;}
    }
}
</script>

<style lang="scss" scoped>
.radio {
    align-items: center;
    color: #4A4A4A;
    display: inline-flex;
    font-size: 1.0rem;
    height: 2.25em;
    outline: none;
    input[type="radio"] {
        left: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        &:checked + .check:after {
            color: #e05f52;
            content: "\f00c";
            font-family: "Font Awesome 5 Free";
            font-size: .75em;
            font-weight: 900;
        }
        &:focus + .check {
            border: solid 1px #3273dc;
            box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);
        }
        &:hover + .check {
            border: solid 1px #3273dc;
        }
    }
    .check {
        align-items: center;
        border: solid 1px #4A4A4A;
        display: inline-flex;
        height: 1.25em;
        justify-content: center;
        text-align: center;
        width: 1.25em;
    }
    .check-label {
        padding-left: .5em;
    }
    &.is-small {
        font-size: .75em;
    }
    &.is-medium {
        font-size: 1.25em;
    }
    &.is-large {
        font-size: 1.5em;
    }
}
</style>
